import React from 'react';

import classes from './CreateNewAssignmentForm.module.css';

import FlexModal from '../../UI/FlexModal/FlexModal';
import IconButton from '../../UI/IconButton/IconButton';
import FormFields from '../FormFields';
import Button from '../../UI/Button/Button';

import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import Input from '../../UI/Input/Input';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import Wrapper from '../../../hoc/Wrapper/Wrapper';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import { parseDateForInputField, parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class CreateNewAssignmentForm extends React.Component {

    state = {
        createNewAssignmentForm: GetObjectClone(FormFields.createNewAssignmentForm),
        createNewAssignmentFormValid: false,
        errorMessage: '',
        showErrorMessage: false,
        showFormErrorMessage: false,
        formErrorMessage: '',
        showToolTip: false
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.createNewAssignmentForm[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;
        if (!IsObjectEmpty(formElement.validation)) {
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                isValid = (value.length > 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }
        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Start Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Start Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Start date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime()) && IsObjectEmpty(this.props.data)) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            } else if (formElement.label === 'End Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // End Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'End date can not be empty';
                }

                let currentDate = new Date();
                let selectedDate = new Date(value + ' 00:00');

                let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                if (!IsStringEmpty(selectedDate.getTime())) {
                    if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                    }
                }
            }
        }

        if (!IsObjectEmpty(rules.startTime)) {
            if (rules.startTime.value && !IsStringEmpty(value)) {
                const startTimeValue = value;
                const startDateValue = this.state.createNewAssignmentForm['startDate'].value;
                const dueTimeValue = this.state.createNewAssignmentForm['dueTime'].value;
                const dueDateValue = this.state.createNewAssignmentForm['dueDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Start Time can not be larger than End Time';
                        this.state.createNewAssignmentForm['dueTime'].errorMessage = '';
                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.createNewAssignmentForm['dueTime'].valid = true;
                    }

                }
            }
        }
        if (!IsObjectEmpty(rules.dueTime)) {
            if (rules.dueTime.value && !IsStringEmpty(value)) {

                const dueTimeValue = value;
                const dueDateValue = this.state.createNewAssignmentForm['dueDate'].value;
                const startTimeValue = this.state.createNewAssignmentForm['startTime'].value;
                const startDateValue = this.state.createNewAssignmentForm['startDate'].value;

                let parsedStartTime = '', parsedDueTime = '';
                if (!IsStringEmpty(startDateValue) && !IsStringEmpty(dueDateValue)) {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse(startDateValue + ' ' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse(dueDateValue + ' ' + dueTimeValue);
                } else {
                    parsedStartTime = IsStringEmpty(startTimeValue) ? '' : Date.parse('01/01/2021' + startTimeValue);
                    parsedDueTime = IsStringEmpty(dueTimeValue) ? '' : Date.parse('01/01/2021' + dueTimeValue);
                }

                if (!IsStringEmpty(parsedStartTime) && !IsStringEmpty(parsedDueTime) && !IsStringEmpty(value) && !IsStringEmpty(startTimeValue)) {
                    if (parsedDueTime < parsedStartTime) {
                        isValid = false && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : 'Due Time can not be smaller than Start Time';
                        this.state.createNewAssignmentForm['startTime'].errorMessage = '';

                        // this.setState((prevState) => ({ createNewAssignmentForm: prevState.createNewAssignment['startTime'].errorMessage = "" }));

                    } else if (parsedDueTime > parsedStartTime) {
                        isValid = true && isValid;
                        formElement.valid = isValid;
                        formElement.errorMessage = isValid ? '' : '';
                        this.state.createNewAssignmentForm['startTime'].valid = true;

                        // this.setState((prevState) => ({ createnewAssignmentForm: prevState.createNewAssignmentForm["startTime"].valid = true }));
                    }
                } else if (IsStringEmpty(parsedDueTime)) {
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'This is a required field';
                }
            }
        }

        if (!IsObjectEmpty(rules.isPercentage) && rules.isPercentage.value && !IsStringEmpty(value)) {

            if ((isNaN(parseInt(value, 10)) === false) && typeof (parseInt(value, 10)) === 'number') {
                isValid = parseInt(value, 10) > 0 && parseInt(value, 10) < 100;
                formElement.errorMessage = isValid ? '' : rules.isPercentage.errorMessage;
                formElement.valid = isValid;
            } else {
                isValid = parseInt(value, 10) > 0 && isValid;
                formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
                formElement.valid = isValid;
            }

        } else if (!IsObjectEmpty(rules.isNumber) && rules.isNumber.value && !IsStringEmpty(value)) {
            isValid = typeof (parseInt(value, 10)) === 'number' && parseInt(value, 10) > 0 && isValid;
            formElement.errorMessage = isValid ? '' : rules.isNumber.errorMessage;
            formElement.valid = isValid;
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.createNewAssignmentForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        let inputValue = event.target.value;

        if (inputIdentifier === 'assignmentTitle' && updatedFormElement.remainingChar > 0) {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);
            inputValue = event.target.value;
        } else if (inputIdentifier === 'assignmentTitle' && updatedFormElement.remainingChar <= 0) {
            inputValue = event.target.value.substring(0, updatedFormElement.totalChar)
        } else {
            inputValue = event.target.value;
        }

        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ createNewAssignmentForm: updatedForm, createNewAssignmentFormValid: formIsValid });
        }
    }

    onCreateAssignmentButtonClick = () => {
        const updatedForm = { ...this.state.createNewAssignmentForm };
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let formErrorMessage = '';
        if (formIsValid) {
            const schedule_date = this.state.createNewAssignmentForm['startDate'].value,
                schedule_time = this.state.createNewAssignmentForm['startTime'].value,
                due_date = this.state.createNewAssignmentForm['dueDate'].value,
                due_time = this.state.createNewAssignmentForm['dueTime'].value;

            const startDate = new Date(schedule_date + ' ' + schedule_time);
            const dueDate = new Date(due_date + ' ' + due_time);

            if (startDate.toLocaleString() === dueDate.toLocaleString()) {
                // formErrorMessage = 'Start Time and Due Time can not be same';
                const dueTimeElement = updatedForm['dueTime'];
                dueTimeElement.valid = false;
                dueTimeElement.errorMessage = 'Due Time and Start Time can not be same';
                updatedForm['dueTime'] = dueTimeElement;
                formIsValid = false;
            } else {
                formErrorMessage = '';
                formIsValid = formIsValid && true;
            }
        }


        this.setState({ createNewAssignmentForm: updatedForm, createNewAssignmentFormValid: formIsValid, showFormErrorMessage: !IsStringEmpty(formErrorMessage), formErrorMessage: formErrorMessage });
        if (formIsValid) {

            let assignmentFormData = {
                "name": this.state.createNewAssignmentForm['assignmentTitle'].value,
                "passing_percentage": this.state.createNewAssignmentForm['passMark'].value,
                "schedule_date": this.state.createNewAssignmentForm['startDate'].value,
                "schedule_time": this.state.createNewAssignmentForm['startTime'].value,
                "due_date": this.state.createNewAssignmentForm['dueDate'].value,
                "due_time": this.state.createNewAssignmentForm['dueTime'].value
            };

            // console.log('Submit Form Data =>>>', assignmentFormData)

            if (this.props.forEdit === true) {
                this.props.editAssignmentDetails(this.props.data.topicId, assignmentFormData);
            } else {
                this.props.createNewAssignment(assignmentFormData);
                // alert('Create new assignment')
            }

        }
    }

    setFormData = () => {
        let updatedForm = { ...this.state.createNewAssignmentForm };

        let assignmentData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(assignmentData)) {

            let assignmentName = '', passMarks = '', startDate = '', startTime = '', dueDate = '', dueTime = '';

            assignmentName = !IsStringEmpty(assignmentData.title) ? assignmentData.title : '';
            passMarks = !IsStringEmpty(assignmentData.passingPercentage) ? assignmentData.passingPercentage : '';

            startDate = !IsStringEmpty(assignmentData.scheduleDate) ? parseDateForInputField(new Date(assignmentData.scheduleDate)) : '';
            dueDate = !IsStringEmpty(assignmentData.dueDate) ? parseDateForInputField(new Date(assignmentData.dueDate)) : '';
            startTime = !IsStringEmpty(assignmentData.scheduleTime) ? parseTimeForInputField(assignmentData.scheduleTime) : '';
            dueTime = !IsStringEmpty(assignmentData.dueTime) ? parseTimeForInputField(assignmentData.dueTime) : '';

            updatedForm['assignmentTitle'].value = assignmentName;
            updatedForm['passMark'].value = passMarks;
            updatedForm['startDate'].value = startDate;
            updatedForm['startTime'].value = startTime;
            updatedForm['dueDate'].value = dueDate;
            updatedForm['dueTime'].value = dueTime;

            this.setState({ createNewAssignmentForm: updatedForm });
        } else if (this.props.forEdit === false && !IsStringEmpty(this.props.selectedDate)) {
            updatedForm['startDate'].value = this.props.selectedDate;
            this.setState({ createNewAssignmentForm: updatedForm });
        }
    }

    componentDidMount() {
        this.setFormData();
    }

    inputFieldAssignment = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.createNewAssignmentForm[key].elementType}
            elementConfig={this.state.createNewAssignmentForm[key].elementConfig}
            label={this.state.createNewAssignmentForm[key].label}
            value={this.state.createNewAssignmentForm[key].value}
            options={this.state.createNewAssignmentForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.createNewAssignmentForm[key].touched}
            afterText={this.state.createNewAssignmentForm[key].remainingChar}
            dropdownOpen={this.state.createNewAssignmentForm[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.createNewAssignmentForm[key].validation) ? (!IsObjectEmpty(this.state.createNewAssignmentForm[key].validation.required) ? this.state.createNewAssignmentForm[key].validation.required.value : false) : false}
            showError={(!this.state.createNewAssignmentFormValid && !this.state.createNewAssignmentForm[key].valid) ? true : false}
            error={this.state.createNewAssignmentForm[key].errorMessage}
        // disableDates={true}
        // disableDateValue={{ minDate: minDate, maxDate: maxDate }}
        />
    }

    render() {
        return (
            <FlexModal visible={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.CreateAssignmentFormContainer}>
                    <div className={classes.CloseIcon}>
                        <IconButton
                            styleclass='NoBorder SmallIcon'
                            icon={closeIconBlack}
                            altText='Close Icon'
                            clicked={() => this.props.closePopup('')}
                        />
                    </div>
                    <h3 className={classes.PopupHeading}>
                        {this.props.forEdit === true ? 'Edit Assignment' : 'Create New Assignment'}
                    </h3>

                    {this.props.showLoader
                        ? <div className={classes.FormLoaderContainer}>
                            <ShowLoader isLoading={this.props.showLoader} transparentBg={true} />
                        </div>
                        : <Wrapper>
                            <div className={classes.FormInput}>
                                {this.inputFieldAssignment('assignmentTitle')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldAssignment('startDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldAssignment('startTime')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldAssignment('dueDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldAssignment('dueTime')}
                            </div>

                            {
                                this.state.showFormErrorMessage
                                    ? <p className={classes.ErrorText}>{this.state.formErrorMessage}</p> : null
                            }

                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                <p className={classes.InputHeading}>Pass Marks</p>
                                <div className={[classes.FormShortWidthInput, classes.AddMarginRight].join(' ')}>
                                    {this.inputFieldAssignment('passMark')} <span>% of total marks</span>
                                </div>
                            </div>


                            <div className={classes.ButtonContainer}>
                                <Button
                                    styleclass="NonMobileOnly"
                                    label={this.props.forEdit ? "UPDATE ASSIGNMENT" : "CREATE ASSIGNMENT"}
                                    clicked={this.onCreateAssignmentButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="16px 20px 20px 0px"
                                />
                                <Button
                                    styleclass="MobileOnly"
                                    label={this.props.forEdit ? "UPDATE ASSIGNMENT" : "CREATE ASSIGNMENT"}
                                    clicked={this.onCreateAssignmentButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </div>
                        </Wrapper>
                    }
                </div>
            </FlexModal>
        );
    }
}

export default CreateNewAssignmentForm;